module.exports = __webpack_public_path__ + "media/icons/skrzynia-biegow@3x-5cc56406.svg";